import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=0947f9fe&scoped=true"
import script from "./Full.vue?vue&type=script&lang=ts"
export * from "./Full.vue?vue&type=script&lang=ts"
import style0 from "./Full.vue?vue&type=style&index=0&id=0947f9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0947f9fe",
  null
  
)

export default component.exports